const successToast = (message, title = null, options = {}) => {
    window.toastr.success(message, title, {
        positionClass: 'toast-top-center',
        closeButton: false,
        progressBar: false,
        preventDuplicates: false,
        newestOnTop: true,
        ...options
    });
};

const infoToast = (message, title = null, options = {}) => {
    window.toastr.info(message, title, {
        positionClass: 'toast-top-center',
        closeButton: false,
        progressBar: false,
        preventDuplicates: false,
        newestOnTop: true,
        ...options
    });
};

const warnToast = (message, title = null, options = {}) => {
    window.toastr.warning(message, title, {
        positionClass: 'toast-top-center',
        closeButton: false,
        progressBar: false,
        preventDuplicates: false,
        newestOnTop: true,
        ...options
    });
};

const errorToast = (message, title = null, options = {}) => {
    window.toastr.error(message, title, {
        positionClass: 'toast-top-center',
        closeButton: false,
        progressBar: false,
        preventDuplicates: false,
        newestOnTop: true,
        ...options
    });
};

export {
    successToast,
    infoToast,
    warnToast,
    errorToast
}


// WEBPACK FOOTER //
// ./src/utils/toasts.js